module.exports = __webpack_public_path__ + "511451c5ea5a6d1d68aaa1d072ba84d7.fbx";